<template>
    <div>
      <v-layout class="d-flex align-center no-gutters" style="flex-wrap: nowrap; overflow-x: auto;">
        <filtro-documentos
            :fornecedores="fornecedores"
            :tipos="tipos"
            :situacoes="situacoes"
            @pesquisar="filtrarDocumentos"
            @limpar="limparFiltros"
        />
      </v-layout>
      <v-divider/>
        <listar-documentos-header-botoes-barra
            :deveHabilitarBotoes="deveHabilitarBotoes"
            @baixarDocumentoEmLote="propagarEventoBaixarDocumentosEmLote"
            @juntarDocumentosEmLote="propagarEventoJuntarDocumentosEmLote"
            @assinarDocumentosEmLote="propagarEventoAssinarDocumentosEmLote"
            />

      <v-data-table
            v-model="documentosSelecionados"
            :headers="headers"
            :items="documentosFiltrados"
            :pagination.sync="pagination"
            select-all item-key="idDocumentoString"
            no-data-text="Não há documentos com esse estado para o fornecedor.">
            >
            <template v-slot:headers="props">
                <tr>
                    <th>
                        <v-checkbox
                            :input-value="todosSelecionados"
                            :indeterminate="indeterminado"
                            color="primary"
                            hide-details
                            @click.stop="alternarSelecaoTodos"
                        ></v-checkbox>
                    </th>
                    <th
                        v-for="header in props.headers"
                        :key="header.text"
                        v-bind="header"
                        :class="['column sortable primary--text font-weight-bold', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click.exact="changeSort(header.value)"
                    >
                        <v-icon small>arrow_upward</v-icon>
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <documento-compra-direta :key="props.item.idDocumentoString"
                                         v-model="props"
                                         @virtualizarDocumentoCompraDireta="(documento) => $emit('virtualizarDocumento', documento)"
                                         @baixarDocumentoCompraDireta="(documento, tipoDownload) => $emit('baixarDocumento', documento, tipoDownload)"
                                         @juntarDocumentoCompraDireta="(documento) => $emit('juntarDocumento', documento)"
                                         @desentranharDocumentoCompraDireta="(documento) => $emit('desentranharDocumento', documento)"
                                         @redigirDocumentoCompraDireta="(documento) => $emit('redigirDocumento', documento)"
                                         @reordenarDocumentoCompraDireta="(documento) => $emit('reordenarDocumento', documento)"
                                         @cancelarDocumentoCompraDireta="(documento) => $emit('cancelarDocumento', documento)"
                                         @documentoSincronizado="$emit('documentoSincronizado', $event)"
                                         @acessarTermoDesentranhamento="(documento) => $emit('acessarTermoDesentranhamento', documento)"/>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import DocumentoCompraDireta from './DocumentoCompraDireta'
import ListarDocumentosHeaderBotoesBarra from './ListarDocumentosHeaderBotoesBarra'
import FiltroDocumentos from '../components/FiltroDocumento.vue'
export default {
    name: 'PainelDocumentosTabelaTodos',
    components: {FiltroDocumentos, ListarDocumentosHeaderBotoesBarra, DocumentoCompraDireta},
    props: {
        documentos: {
            type: Array,
            required: true,
            default: () => []
        },
        operacaoExecutadaComSucesso: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        pagination: {
            sortBy: 'nome',
            rowsPerPage: 10,
            page: 1
        },
        headers: [
            {
                text: 'Documento',
                value: 'nome',
                align: 'left'
            },
            {
                text: 'Tipo',
                value: 'descricaoTipo',
                align: 'left'
            },
            {
                text: 'Fornecedor',
                value: 'fornecedorNome',
                align: 'left'
            },
            {
                text: 'Assinaturas',
                value: 'quantidadeAssinaturas',
                align: 'center'
            },
            {
                text: 'Situação',
                value: 'situacao',
                align: 'left'
            },
            {
                text: 'Ações',
                sortable: false,
                align: 'center',
            }
        ],
        documentosSelecionados:[],
        documentosFiltrados: [],
        filtros: {
            fornecedor: null,
            tipo: null,
            situacao: null
        }
    }),
    computed: {
        documentosSelecionaveis() {
            return this.documentosFiltrados.filter(documento => {
                if (!documento) return true
                
                const tipoDoc = (documento.tipo || '').toLowerCase()
                const descricaoTipoDoc = (documento.descricaoTipo || '').toLowerCase()
                const situacaoDoc = (documento.situacao || '').toLowerCase()
                
                const isTermoDesentranhamento = tipoDoc.includes('termo') && tipoDoc.includes('desentranhamento') ||
                                              descricaoTipoDoc.includes('termo') && descricaoTipoDoc.includes('desentranhamento')
                
                const isSituacaoGerado = situacaoDoc.includes('gerado')
                
                return !(isTermoDesentranhamento && isSituacaoGerado)
            })
        },
        todosSelecionados() {
            return (
                this.documentosSelecionaveis.length > 0 &&
                this.documentosSelecionaveis.every(item =>
                    this.documentosSelecionados.some(sel => sel.idDocumentoString === item.idDocumentoString)
                )
            )
        },
        indeterminado() {
            return (
                this.documentosSelecionados.length > 0 &&
                !this.todosSelecionados
            )
        },
        deveHabilitarBotoes(){
            return this.documentosSelecionados.length > 0
        },
        tipos() {
            const tipos = new Set(this.documentos.map(doc => doc.descricaoTipo).filter(Boolean))
            return ['Todos', ...Array.from(tipos)]
        },
        fornecedores() {
            const fornecedores = new Set(this.documentos.map(doc => doc.fornecedorNome).filter(Boolean))
            return ['Todos', ...Array.from(fornecedores)]
        },
        situacoes() {
            const situacoes = new Set(this.documentos.map(doc => doc.situacao).filter(Boolean))
            return ['Todos', ...Array.from(situacoes)]
        }
    },
    mounted() {
        this.documentosFiltrados = this.documentos
    },
    methods: {
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        propagarEventoBaixarDocumentosEmLote(){
            this.$emit('baixarDocumentoEmLote', [...this.documentosSelecionados])
        },
        propagarEventoJuntarDocumentosEmLote(){
            this.$emit('juntarDocumentosEmLote', [...this.documentosSelecionados])
        },
        propagarEventoAssinarDocumentosEmLote(){
            this.$emit('assinarDocumentosEmLote', [...this.documentosSelecionados])

        },
        filtrarDocumentos(filtros) {
            this.filtros = filtros

            this.documentosFiltrados = this.documentos.filter(doc => {
                const tipoOk = filtros.tipo === 'Todos' || !filtros.tipo || doc.descricaoTipo === filtros.tipo
                const fornecedorOk = filtros.fornecedor === 'Todos' || !filtros.fornecedor || doc.fornecedorNome === filtros.fornecedor
                const situacaoOk = filtros.situacao === 'Todos' || !filtros.situacao || doc.situacao === filtros.situacao

                return tipoOk && fornecedorOk && situacaoOk
            })
        },
        limparFiltros() {
            this.filtros = {
                fornecedor: null,
                tipo: null,
                situacao: null
            }
            this.documentosFiltrados = this.documentos
        },
        alternarSelecaoTodos() {
            if (this.todosSelecionados) {
                this.documentosSelecionados = this.documentosSelecionados.filter(
                    sel => !this.documentosSelecionaveis.some(doc => doc.idDocumentoString === sel.idDocumentoString)
                )
            } else {
                const novosSelecionados = this.documentosSelecionaveis.filter(doc =>
                    !this.documentosSelecionados.some(sel => sel.idDocumentoString === doc.idDocumentoString)
                )
                this.documentosSelecionados = [...this.documentosSelecionados, ...novosSelecionados]
            }
        }

    },
    watch: {
        documentos: {
            handler(novos) {
                this.documentosFiltrados = novos
            },
            immediate: true
        },
        operacaoExecutadaComSucesso(value) {
            if (value === true)
                this.documentosSelecionados = []
        }
    }
}
</script>